
<template>
  <div>

    <b-button
      v-permission="'documents.create'"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="addNew">
      <feather-icon
        icon="PlusIcon"
        class="mr-50"/>
      <span class="align-middle">{{$t('AddNew')}}</span>
    </b-button>

    <Grid :service="service" route_name="documents" :ref="'grid'">
      <template v-slot:actions="actions">
        <div class="flex flex-row gap-2">
          <feather-icon
            v-permission="`documents.edit`"
            icon="EditIcon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
            v-tooltip.top="{
              content: 'Editar',
              delay: { show: 100, hide: 100 }
            }"
            @click="edit(actions.row.id)"/>
          <feather-icon
            v-permission="'documents.detail'"
            icon="EyeIcon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
            v-tooltip.top="{
              content: 'Detalhar',
              delay: { show: 100, hide: 100 }
            }"
            @click="detail(actions.row.id)"/>
            <feather-icon
              v-permission="'documents.download_all'"
              v-if="actions.row.filesCount > 0"
              icon="DownloadIcon"
              class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
              v-tooltip.top="{
                content: 'Baixar todos os documentos anexados',
                delay: { show: 100, hide: 100 }
              }"
              @click="downloadAll(actions.row.id, actions.row.title)"/>
          <feather-icon
            v-permission="`documents.delete`"
            icon="Trash2Icon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-danger"
            v-tooltip.top="{
              content: 'Excluir',
              delay: { show: 100, hide: 100 }
            }"
            @click="destroy(actions.row)"/>
        </div>
      </template>
    </Grid>
  </div>
</template>


<script>
import KnowledgeService from '@/services/api/DocumentService'

import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton
  },
  data: () => ({
    selected: [],
    service: null
  }),
  methods: {
    addNew() {
      this.$router.push('/documents/create')
    },
    grid() {
      return this.$refs['grid']
    },
    detail(id) {
      this.$router.push({
        name: 'document-detail',
        params: {
          id: id
        }
      })
    },
    edit(id) {
      this.$router.push({
        name: 'document-edit',
        params: {
          id: id
        }
      })
    },
    destroy(data) {
      const grid = this.grid()
      if (grid) {
        grid.destroy(data)
      }
    },
    downloadAll(id, title){
      this.notifySuccess(this.$vs, 'Aguarde... processando sua solicitação!')

      this.service.getFilesDownloadLink(id).then(
        (data) => {
          this.notifySuccess(this.$vs, 'Iniciando Download...')
          const openTab = () => {this.$utils.browser.newTab(data.link)}
          openTab()
        },
        (error) => {
          this.notifyError(this.$vs, 'Erro! Não foi possível iniciar o download dos arquivos.')
        }
      )
      /*
      this.service.downloadAll(id, title+'.zip').then(
        (success) => {
          this.notifySuccess(this.$vs, 'Iniciando Download...')
        },
        (error) => {
          this.notifyError(this.$vs, 'Erro! Não foi possível iniciar o download dos arquivos.')
        }
      )
      */
    },
  },
  beforeMount() {
    this.service = KnowledgeService.build(this.$vs)
  }
}
</script>
